// extracted by mini-css-extract-plugin
export default {"tutorial":"Tutorial_tutorial__k1idA","btn":"Tutorial_btn__ULXlt"};